import { render } from "./비만근감소클리닉.vue?vue&type=template&id=3c045eee"
import script from "./비만근감소클리닉.vue?vue&type=script&lang=js"
export * from "./비만근감소클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__